import { render, staticRenderFns } from "./EditPrenatal.vue?vue&type=template&id=4f041e25&scoped=true"
import script from "./EditPrenatal.vue?vue&type=script&lang=js"
export * from "./EditPrenatal.vue?vue&type=script&lang=js"
import style0 from "./EditPrenatal.vue?vue&type=style&index=0&id=4f041e25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f041e25",
  null
  
)

export default component.exports